function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.352",
  height: "22.353"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3340",
  "data-name": "Rectangle 3340",
  fill: "#453f94",
  d: "M0 0h22.352v22.353H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_7107",
  "data-name": "Group 7107"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7094",
  "data-name": "Group 7094",
  clipPath: "url(#clip-path)",
  fill: "#453f94"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4230",
  "data-name": "Path 4230",
  d: "M11.176 0a11.177 11.177 0 1011.176 11.176A11.189 11.189 0 0011.176 0m0 20.052a8.875 8.875 0 118.875-8.876 8.885 8.885 0 01-8.875 8.876"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4231",
  "data-name": "Path 4231",
  d: "M6.567 9.853a1.475 1.475 0 101.475 1.475 1.475 1.475 0 00-1.475-1.475"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4232",
  "data-name": "Path 4232",
  d: "M11.132 9.853a1.475 1.475 0 101.475 1.475 1.475 1.475 0 00-1.475-1.475"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4233",
  "data-name": "Path 4233",
  d: "M15.7 9.853a1.475 1.475 0 101.475 1.475A1.475 1.475 0 0015.7 9.853"
})))));